import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIndeterminateEligibility = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      cx={12}
      cy={12}
      r={11.25}
      fill="#FFF7DB"
      stroke="#F2A218"
      strokeDasharray="2 3"
      strokeWidth={1.5}
    />
    <path
      fill="#F2A218"
      d="M11.074 14.492c0-1.424.256-2.272 1.568-3.344l.4-.336c.544-.432 1.056-1.04 1.056-1.856 0-.992-.72-1.76-1.968-1.76-1.424 0-2.272.976-2.272 2.528H8.434c0-2.304 1.552-3.68 3.696-3.68 2.016 0 3.424 1.296 3.424 2.816 0 1.312-.704 2.16-1.712 2.96l-.432.352c-.688.56-.944 1.184-.944 2.32zm-.112 3.008v-1.744h1.648V17.5z"
    />
  </svg>
);
export default SvgIndeterminateEligibility;
